import { Dispatch } from "redux";
import {
  getNextPaymentsCount,
  getPaymentsTransaction,
  getPaymentsTotal,
  getPaymentsDate,
  resetPaymentsStateAction
} from "./PaymentsActions";
import API from "../../API";

export const getNextPayout = () => async (dispatch: Dispatch) => {
  try {
    dispatch(getNextPaymentsCount.request());
    const nextPaymentsData = await API.get('/payments/next-payout');
    dispatch(getNextPaymentsCount.success({ nextPayout: nextPaymentsData?.data }));
  } catch (err) {
    console.log(err, 'errrr')
    dispatch(getNextPaymentsCount.fail(err));
  }
};

export const getPaymentsTranastion = (params: Object) => async (dispatch: Dispatch) => {
  try {
    dispatch(getPaymentsTransaction.request());
    const paymentsData = await API.get('/payments/transactions', { params });
    dispatch(getPaymentsTransaction.success({ data: paymentsData?.data, paymentsData: paymentsData?.data.data, page: paymentsData?.data.meta.current_page, lastPage: paymentsData?.data.meta.last_page }));
  } catch (err) {
    console.log(err, 'errrr')
    dispatch(getPaymentsTransaction.fail(err));
  }
};

export const getPaymentsTranastionTotoal = (params: Object) => async (dispatch: Dispatch) => {
  try {
    dispatch(getPaymentsTotal.request());
    const paymentsTotal = await API.get('/payments/transactions/total', { params });
    dispatch(getPaymentsTotal.success({ paymentsTotal: paymentsTotal?.data }));
  } catch (err) {
    console.log(err, 'errrr')
    dispatch(getPaymentsTotal.fail(err));
  }
};

export const getPaymentsStartAndEndDate = (data: any) => async (dispatch: Dispatch) => {
  try {
    dispatch(getPaymentsDate.request());
    dispatch(getPaymentsDate.success(data));
  } catch (err) {
    console.log(err, 'errrr')
    dispatch(getPaymentsDate.fail(err));
  }
};

export const resetPaymentsState = () => async (dispatch: Dispatch) => {
  try {
    dispatch(resetPaymentsStateAction.request());
    dispatch(resetPaymentsStateAction.success());
  } catch (err) {
    console.log(err, 'errrr')
    dispatch(resetPaymentsStateAction.fail(err));
  }
};
